import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ParamsConst, RolesString, RoutesCons } from './constants/const';
import { GuardService } from './services/guard.service';
import { IsCardCodeResolver } from './services/is-card-code.resolver';
import { ChangesConfirmationGuard } from './guards/changes-confirmation.guard';
import { ChangesConfirmationUtilitiesGuard } from './guards/changes-confirmation-utilities.guard';

const routes: Routes = [
  {
    path: RoutesCons.home,
    canActivate: [GuardService],
    resolve: { cardCode: IsCardCodeResolver },
    data: {
      roles: [RolesString.doctor, RolesString.advisor, RolesString.reporter, RolesString.adminPromo],
    },
    loadChildren: () =>
      import('./pages/home/home.module').then((m) => m.HomeModule),
  },
  {
    path: `${RoutesCons.missingProducts}`,
    canActivate: [GuardService],
    resolve: { cardCode: IsCardCodeResolver },
    data: {
      roles: [RolesString.reporter, RolesString.advisor],
    },
    loadChildren: () =>
      import('./pages/missing-products/missing-products.module').then(
        (m) => m.MissingProductsModule
      ),
  },
  {
    path: `${RoutesCons.generateOrderAdvisor}/:${ParamsConst.cardCode}`,
    canActivate: [GuardService],
    resolve: { cardCode: IsCardCodeResolver },
    data: {
      roles: [RolesString.advisor],
    },
    loadChildren: () =>
      import('./pages/generate-order-asesor/generate-order-asesor.module').then((m) => m.GenerateOrderAsesorModule),
  },
  {
    path: RoutesCons.utilities,
    canActivate: [GuardService],
    resolve: { cardCode: IsCardCodeResolver },
    canDeactivate: [ ChangesConfirmationUtilitiesGuard ],
    data: {
      roles: [RolesString.doctor],
    },
    loadChildren: () =>
      import('./pages/utilities/utilities.module').then((m) => m.UtilitiesModule),
  },
  {
    path: `${RoutesCons.shoppingCar}/:${ParamsConst.shoppingTab}`,
    canActivate: [GuardService],
    resolve: { cardCode: IsCardCodeResolver },
    data: {
      roles: [RolesString.doctor],
    },
    loadChildren: () =>
      import('./pages/list-shopping-car/list-shopping-car.module').then(
        (m) => m.ListShoppingCarModule
      ),
  },
  {
    path: RoutesCons.shoppingCar,
    canActivate: [GuardService],
    resolve: { cardCode: IsCardCodeResolver },
    data: {
      roles: [RolesString.doctor],
    },
    loadChildren: () =>
      import('./pages/list-shopping-car/list-shopping-car.module').then(
        (m) => m.ListShoppingCarModule
      ),
  },
  {
    path: RoutesCons.myProducts,
    canActivate: [GuardService],
    resolve: { cardCode: IsCardCodeResolver },
    data: {
      roles: [RolesString.doctor],
    },
    loadChildren: () =>
      import('./pages/myActivity/my-products/my-products.module').then(
        (m) => m.MyProductsModule
      ),
  },
  {
    path: RoutesCons.promotions,
    canActivate: [GuardService],
    resolve: { cardCode: IsCardCodeResolver },
    data: {
      roles: [RolesString.doctor],
    },
    loadChildren: () =>
      import('./pages/promotions/promotions.module').then(
        (m) => m.PromotionsModule
      ),
  },
  {
    path: RoutesCons.historyOrders,
    canActivate: [GuardService],
    resolve: { cardCode: IsCardCodeResolver },
    data: {
      roles: [RolesString.doctor],
    },
    loadChildren: () =>
      import('./pages/myActivity/history-orders/history-orders.module').then(
        (m) => m.HistoryOrdersModule
      ),
  },
  {
    path: RoutesCons.activeOrders,
    canActivate: [GuardService],
    resolve: { cardCode: IsCardCodeResolver },
    data: {
      roles: [RolesString.doctor],
    },
    loadChildren: () =>
      import('./pages/active-orders/active-orders.module').then(
        (m) => m.ActiveOrdersModule
      ),
  },
  {
    path: RoutesCons.deliveredOrders,
    canActivate: [GuardService],
    resolve: { cardCode: IsCardCodeResolver },
    data: {
      roles: [RolesString.doctor],
    },
    loadChildren: () =>
      import('./pages/delivered-orders/delivered-orders.module').then(
        (m) => m.DeliveredOrdersModule
      ),
  },
  {
    path: RoutesCons.myFavourites,
    canActivate: [GuardService],
    resolve: { cardCode: IsCardCodeResolver },
    data: {
      roles: [RolesString.doctor],
    },
    loadChildren: () =>
      import('./pages/myActivity/my-favourites/my-favourites.module').then(
        (m) => m.MyFavouritesModule
      ),
  },
  {
    path: `${RoutesCons.myProfile}/:cardCode`,
    canActivate: [GuardService],
    resolve: { cardCode: IsCardCodeResolver },
    canDeactivate: [ ChangesConfirmationGuard ],
    data: {
      roles: [RolesString.doctor, RolesString.advisor],
    },
    loadChildren: () =>
      import('./pages/my-profile/my-profile.module').then(
        (m) => m.MyProfileModule
      ),
  },
  {
    path: `${RoutesCons.myProfile}`,
    redirectTo: `${RoutesCons.myProfile}/`
  },
  {
    path: RoutesCons.editBuyOrder + '/:keyStorage',
    canActivate: [GuardService],
    resolve: { cardCode: IsCardCodeResolver },
    data: {
      roles: [RolesString.doctor, RolesString.advisor],
    },
    loadChildren: () =>
      import('./pages/edit-buy-order/edit-buy-order.module').then(
        (m) => m.EditBuyOrderComponentModule
      ),
  },
  {
    path: `${RoutesCons.orderResume}/:keyStorage`,
    canActivate: [GuardService],
    resolve: { cardCode: IsCardCodeResolver },
    data: {
      roles: [RolesString.doctor, RolesString.advisor],
    },
    loadChildren: () =>
      import('./pages/order-resume/order-resume.module').then(
        (m) => m.OrderResumeModule
      ),
  },
  {
    path: RoutesCons.deliveryData + '/:keyStorage',
    data: {
      roles: [RolesString.doctor, RolesString.advisor],
    },
    canActivate: [GuardService],
    resolve: { cardCode: IsCardCodeResolver },
    loadChildren: () =>
      import('./pages/delivery-data/delivery-data.module').then(
        (m) => m.DeliveryDataModule
      ),
  },
  {
    path: RoutesCons.taxData + '/:keyStorage',
    data: {
      roles: [RolesString.doctor, RolesString.advisor],
    },
    canActivate: [GuardService],
    resolve: { cardCode: IsCardCodeResolver },
    loadChildren: () =>
      import(
        './pages/tax-data-and-payment-data/tax-data-and-payment-data.module'
      ).then((m) => m.TaxDataAndPaymentDataModule),
  },
  {
    path: `${RoutesCons.pendingOrder}/:cardCode/:transactionId`,
    canActivate: [GuardService],
    resolve: { cardCode: IsCardCodeResolver },
    data: {
      roles: [RolesString.doctor],
    },
    loadChildren: () =>
      import('./pages/my-pending-orders/my-pending-orders.module').then(
        (m) => m.MyPendingOrdersModule
      ),
  },
  {
    path: `${RoutesCons.pendingOrder}`,
    canActivate: [GuardService],
    resolve: { cardCode: IsCardCodeResolver },
    data: {
      roles: [RolesString.doctor],
    },
    loadChildren: () =>
      import('./pages/my-pending-orders/my-pending-orders.module').then(
        (m) => m.MyPendingOrdersModule
      ),
  },
  {
    path: RoutesCons.doctorList,
    canActivate: [GuardService],
    resolve: { cardCode: IsCardCodeResolver },
    data: {
      roles: [RolesString.advisor],
    },
    loadChildren: () =>
      import('./pages/doctor-list/doctor-list.module').then(
        (m) => m.DoctorListModule
      ),
  },
  {
    path: `${RoutesCons.confirmOrders}/:keyStorage/:${ParamsConst.typeCart}`,
    canActivate: [GuardService],
    resolve: { cardCode: IsCardCodeResolver },
    data: {
      roles: [RolesString.doctor, RolesString.advisor],
    },
    loadChildren: () =>
      import('./pages/confirm-order/confirm-order.module').then(
        (m) => m.ConfirmOrderModule
      ),
  },
  {
    path: `${RoutesCons.createMissingProduct}/:TYPE/:S_S_KEY`,
    canActivate: [GuardService],
    resolve: { cardCode: IsCardCodeResolver },
    data: {
      roles: [RolesString.advisor, RolesString.reporter]
    },
    loadChildren: () =>
      import('./pages/create-product/create-order.module').then(
        (m) => m.CreateProductModule
      ),
  },
  {
    path: `${RoutesCons.incidents}`,
    canActivate: [GuardService],
    canDeactivate: [ ChangesConfirmationGuard ],
    resolve: { cardCode: IsCardCodeResolver },
    data: {
      roles: [RolesString.doctor, RolesString.advisor],
    },
    loadChildren: () =>
      import('./pages/incidents/incidents.module').then(
        (m) => m.IncidentsModule
      ),
  },
  {
    path: `${RoutesCons.listProduct}/:${'type'}`,
    canActivate: [GuardService],
    resolve: { cardCode: IsCardCodeResolver },
    data: {
      roles: [RolesString.doctor],
    },
    loadChildren: () =>
      import('./pages/list-of-products/list-of-products-module').then(
        (m) => m.ListOfProductsModule
      ),
  },
  {
    path: `${RoutesCons.listProduct}/:${'type'}/:product`,
    canActivate: [GuardService],
    resolve: { cardCode: IsCardCodeResolver },
    data: {
      roles: [RolesString.doctor],
    },
    loadChildren: () =>
      import('./pages/list-of-products/list-of-products-module').then(
        (m) => m.ListOfProductsModule
      ),
  },
  {
    path: `${RoutesCons.invoicesPending}`,
    canActivate: [GuardService],
    resolve: { cardCode: IsCardCodeResolver },
    data: {
      roles: [RolesString.doctor],
    },
    loadChildren: () =>
      import('./pages/invoices-pending/invoices-pending.module').then(
        (m) => m.InvoicesPendingModule
      ),
  },
  {
    path: `${RoutesCons.invoicesPaid}`,
    canActivate: [GuardService],
    resolve: { cardCode: IsCardCodeResolver },
    data: {
      roles: [RolesString.doctor],
    },
    loadChildren: () =>
      import('./pages/invoices-paid/invoices-paid.module').then(
        (m) => m.InvoicesPaidModule
      ),
  },
  {
    path: RoutesCons.averageTicket,
    canActivate: [GuardService],
    resolve: { cardCode: IsCardCodeResolver },
    data: {
      roles: [RolesString.advisor],
    },
    loadChildren: () =>
      import('./pages/average-ticket/average-ticket.module').then(
        (m) => m.AverageTicketModule
      ),
  },
  {
    path: RoutesCons.clientsWallet,
    canActivate: [GuardService],
    resolve: { cardCode: IsCardCodeResolver },
    data: {
      roles: [RolesString.advisor],
    },
    loadChildren: () =>
      import('./pages/clients-wallet-report/clients-wallet-report.module').then(
        (m) => m.ClientsWalletReportModule
      ),
  },
  {
    path: RoutesCons.paymentAndBillings,
    canActivate: [GuardService],
    resolve: { cardCode: IsCardCodeResolver },
    data: {
      roles: [RolesString.advisor],
    },
    loadChildren: () =>
      import('./pages/payment-and-bills-report/payment-and-bills-report.module').then(
        (m) => m.PaymentAndBillsReportModule
      ),
  },
  {
    path: RoutesCons.tradeCube,
    canActivate: [GuardService],
    resolve: { cardCode: IsCardCodeResolver },
    data: {
      roles: [RolesString.advisor],
    },
    loadChildren: () =>
      import('./pages/trade-cube-report/trade-cube-report.module').then(
        (m) => m.TradeCubeReportModule
      ),
  },
  {
    path: RoutesCons.goals,
    canActivate: [GuardService],
    resolve: { cardCode: IsCardCodeResolver },
    data: {
      roles: [RolesString.advisor],
    },
    loadChildren: () =>
      import('./pages/goals/goals.module').then(
        (m) => m.GoalsModule
      ),
  },
  {
    path: RoutesCons.generateOrder,
    canActivate: [GuardService],
    resolve: { cardCode: IsCardCodeResolver },
    data: {
      roles: [RolesString.doctor],
    },
    loadChildren: () =>
      import('./pages/generate-order/generate-order.module').then(
        (m) => m.GenerateOrderModule
      ),
  },
  {
    path: RoutesCons.catalogClassifications,
    canActivate: [GuardService],
    resolve: { cardCode: IsCardCodeResolver },
    data: {
      roles: [RolesString.doctor],
    },
    loadChildren: () =>
      import('./pages/catalog-classifications/catalog-classifications.module').then(
        (m) => m.CatalogClassificationsModule
      ),
  },
  {
    path: `${RoutesCons.invoicesPending}/:${ParamsConst.cardCode}`,
    canActivate: [GuardService],
    resolve: { cardCode: IsCardCodeResolver },
    data: {
      roles: [RolesString.advisor],
    },
    loadChildren: () => import('./pages/advisor-invoices-pending/advisor-invoices-pending.module').then(
      (m) => m.AdvisorInvoicesPendingModule
    )
  },
  {
    path: `${RoutesCons.orders}/:${ParamsConst.orderOption}/:${ParamsConst.cardCode}`,
    canActivate: [GuardService],
    resolve: { cardCode: IsCardCodeResolver },
    data: {
      roles: [RolesString.advisor],
    },
    loadChildren: () =>
      import('./pages/advisor-orders/advisor-orders.module').then(
        (m) => m.AdvisorOrdersModule
      ),
  },
  {
    path: `${RoutesCons.advisorUtilities}/:${ParamsConst.cardCode}`,
    canActivate: [GuardService],
    resolve: { cardCode: IsCardCodeResolver },
    data: {
      roles: [RolesString.advisor],
    },
    loadChildren: () =>
      import('./pages/advisor-utilities/advisor-utilities.module').then(
        (m) => m.AdvisorUtilitiesModule
      ),
  },
  {
    path: `${RoutesCons.pay}/:${ParamsConst.key}`,
    canActivate: [GuardService],
    resolve: { cardCode: IsCardCodeResolver },
    data: {
      roles: [RolesString.doctor]
    },
    loadChildren: () =>
      import('./pages/pay/pay.module').then(
        (m) => m.PayModule
      ),
  },
  {
    path: `${RoutesCons.missigList}/:key`,
    canActivate: [GuardService],
    resolve: { cardCode: IsCardCodeResolver },
    data: {
      roles: [RolesString.advisor]
    },
    loadChildren: () =>
      import('./pages/missing-list-products/missing-list-products.module').then(
        (m) => m.MissingListProductsModule
      ),
  },
  {
    path: `${RoutesCons.advisorCatalogsClassification}`,
    canActivate: [GuardService],
    resolve: { cardCode: IsCardCodeResolver },
    data: {
      roles: [RolesString.advisor]
    },
    loadChildren: () =>
      import('./pages/advisor-catalogs-classification/advisor-catalogs-classification.module').then(
        (m) => m.AdvisorCatalogsClassificationModule
      ),
  },
  {
    path: `${RoutesCons.advisorCatalog}/:${'type'}`,
    canActivate: [GuardService],
    resolve: { cardCode: IsCardCodeResolver },
    data: {
      roles: [RolesString.advisor],
    },
    loadChildren: () =>
      import('./pages/advisor-catalogs/advisor-catalogs.module').then(
        (m) => m.AdvisorCatalogsModule
      ),
  },
  {
    path: `${RoutesCons.faqs}`,
    canActivate: [GuardService],
    resolve: { cardCode: IsCardCodeResolver },
    data: {
      roles: [RolesString.doctor, RolesString.advisor],
    },
    loadChildren: () =>
      import('./pages/faqs/faqs.module').then(
        (m) => m.FAQsModule
      ),
  },
  {
    path: `${RoutesCons.openOrdersReport}`,
    canActivate: [GuardService],
    resolve: { cardCode: IsCardCodeResolver },
    data: {
      roles: [RolesString.advisor],
    },
    loadChildren: () =>
      import('./pages/open-orders-report/open-orders-report.module').then(
        (m) => m.OpenOrdersReportModule
      ),
  },
  {
    path: `${RoutesCons.detailReport}/:id`,
    canActivate: [GuardService],
    resolve: { cardCode: IsCardCodeResolver },
    data: {
      roles: [RolesString.advisor],
    },
    loadChildren: () =>
      import('./pages/detail-order-sap-report/detail-order-sap-report.module').then(
        (m) => m.DetailOrderSapReportModule
      ),
  },
  {
    path: `${RoutesCons.recipeConfiguration}/:id`,
    canActivate: [GuardService],
    resolve: { cardCode: IsCardCodeResolver },
    canDeactivate: [ ChangesConfirmationGuard ],
    data: {
      roles: [RolesString.doctor],
    },
    loadChildren: () =>
      import('./pages/recipe-configuration/recipe-configuration.module').then(
        (m) => m.RecipeConfigurationModule
      ),
  },
  {
    path: `${RoutesCons.paymentFailure}/:${ParamsConst.transactionId}/:${ParamsConst.paymentType}`,
    canActivate: [GuardService],
    resolve: { cardCode: IsCardCodeResolver },
    data: {
      roles: [RolesString.doctor],
    },
    loadChildren: () =>
      import('./pages/failure-bbvapayment/failure-bbvapayment.module').then(
        (m) => m.FailureBBVAPaymentModule
      ),
  },
  {
    path: `${RoutesCons.paymentSuccess}/:${ParamsConst.transactionId}/:${ParamsConst.paymentType}`,
    canActivate: [GuardService],
    resolve: { cardCode: IsCardCodeResolver },
    data: {
      roles: [RolesString.doctor],
    },
    loadChildren: () =>
      import('./pages/sucess-bbvapayment/sucess-bbvapayment.module').then(
        (m) => m.SucessBBVAPaymentModule
      ),
  },
  {
    path: `${RoutesCons.managePromotionCodes}`,
    canActivate: [GuardService],
    resolve: { cardCode: IsCardCodeResolver },
    data: {
      roles: [RolesString.adminPromo],
    },
    loadChildren: () =>
      import('./pages/manage-promotions-code/manage-promotions-code.module').then(
        (m) => m.ManagePromotionsCodeModule
      ),
  },
  {
    path: `${RoutesCons.createPromotionCode}`,
    canActivate: [GuardService],
    resolve: { cardCode: IsCardCodeResolver },
    data: {
      roles: [RolesString.adminPromo],
    },
    loadChildren: () =>
      import('./pages/generate-promotions-code/generate-promotions-code.module').then(
        (m) => m.GeneratePromotionsCodeModule
      ),
  },
  {
    path: `${RoutesCons.editPromotionCode}/:${ParamsConst.key}`,
    canActivate: [GuardService],
    resolve: { cardCode: IsCardCodeResolver },
    data: {
      roles: [RolesString.adminPromo],
    },
    loadChildren: () =>
      import('./pages/edit-promotion-code/edit-promotion-code.module').then(
        (m) => m.EditPromotionCodeModule
      ),
  },
  {
    path: `${RoutesCons.generalSearch}`,
    canActivate: [GuardService],
    resolve: { cardCode: IsCardCodeResolver },
    data: {
      roles: [RolesString.doctor],
    },
    loadChildren: () =>
      import('./pages/search-results/search-results.module').then(
        (m) => m.SearchResultsModule
      ),
  },
  {
    path: `${RoutesCons.responsibleDoctorInfo}`,
    canActivate: [GuardService],
    resolve: { cardCode: IsCardCodeResolver },
    data: {
      roles: [RolesString.doctor]
    },
    loadChildren: () => import('./pages/responsible-doctor-information/responsible-doctor-information.module').then(
      (m) => m.ResponsibleDoctorInformationModule
    )
  },
  {
    path: `${RoutesCons.analysisBusiness}`,
    canActivate: [GuardService],
    resolve: { cardCode: IsCardCodeResolver },
    data: {
      roles: [RolesString.doctor, RolesString.advisor]
    },
    loadChildren: () => import('./pages/analysis-my-business/analysis-my-business.module').then(
      (m) => m.AnalysisMyBusinessModule
    )
  },
  {
    path: `${RoutesCons.potencialBusiness}`,
    canActivate: [GuardService],
    resolve: { cardCode: IsCardCodeResolver },
    data: {
      roles: [RolesString.doctor, RolesString.advisor]
    },
    loadChildren: () => import('./pages/potencial-my-business/potencial-my-business.module').then(
      (m) => m.PotencialMyBusinessModule
    )
  },
  {
    path: '',
    redirectTo: `/${RoutesCons.home}`,
    resolve: { cardCode: IsCardCodeResolver },
  },
  {
    path: '**',
    redirectTo: `/${RoutesCons.home}`,
    resolve: { cardCode: IsCardCodeResolver },
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule { }
